import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { paymentHistory } from '../../redux/actions/settingActions';
import { useSelector } from 'react-redux';

const SettingPaymentHistory = (props) => {
    const dispatch = useDispatch();
    const pHistory = useSelector((state) => state.setting.paymentHistory);

    useEffect(() => {
        dispatch(paymentHistory(props.authToken));
      }, []);


      
      

  return (
    <div className="px-4 sm:px-6 lg:px-8">
    <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
            <div className="text-lg leading-7 font-[500] my-auto">Payment History</div>  
            {/* <button
              type="button"
              className="mr-4 inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] px-3 py-2 text-sm font-semibold text-white shadow-sm"
              onClick={()=>{handleSubmit();}}
            >
            Save Changes
          </button>             */}
          </div>
          <div className='h-[75vh] overflow-y-auto px-12 rounded-md bg-white'>

    <div className="flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle">
          <table className="min-w-full divide-y divide-gray-300 ">
            <thead>
              <tr>
                <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                  Amount
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Plan
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Email
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                  Date
                </th>
                <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 ">
              {pHistory?.data?.map((person) => (
                <tr key={person.email}>
                  <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                  {person.currency === "INR" ? "₹" : "$"}{person.amount}
                  </td>
                  <td className="whitespace-nowrap px-2 py-4 text-sm text-gray-500">{person?.plan_name}</td>
                  <td className="whitespace-nowrap px-2 py-4 text-sm text-gray-500">{person?.meta_data?.notes?.customer_details?.email}</td>
                  <td className="whitespace-nowrap px-2 py-4 text-sm text-gray-500">{person.created_at}</td>
                  <td className={`whitespace-nowrap px-3 py-4 text-sm text-black font-bold text-center ${person.payment_status == "captured" ? "bg-green-300" :"bg-red-300"}`}>{person.payment_status == "captured" ? "Succeeded" : "Failed"}</td>
                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
          </div>
  </div>
  )
}

export default SettingPaymentHistory